module.exports = __webpack_public_path__ + "static/Fischer.14092644.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Fischer.jpg
// module id = 464
// module chunks = 213187215133716